module.exports = __webpack_public_path__ + "img/03.16fb8209.jpg";